var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c(
        "swiper",
        {
          ref: "domainNavigation",
          staticClass: "domain-navigation",
          attrs: { options: _vm.domainNavigationOptions }
        },
        [
          _vm._l(_vm.navigationItems, function(nav, index) {
            return _c(
              "swiper-slide",
              {
                key: index,
                class: { "domain-navigation__item--disabled": !nav.isActive }
              },
              [
                nav.isActive
                  ? [
                      nav.manage_href
                        ? [
                            _c(
                              "a",
                              _vm._g(
                                {
                                  staticClass: "btn--domain-action",
                                  class: _vm.isNavActiveClass(nav),
                                  attrs: { href: nav.manage_href }
                                },
                                {
                                  click: function() {
                                    if (nav.click) {
                                      nav.click()
                                    }
                                  }
                                }
                              ),
                              [
                                _c("span", {
                                  staticClass: "icon-ccs",
                                  class: nav.icon
                                }),
                                _c("br"),
                                _c("span", { staticClass: "label-ccs" }, [
                                  _vm._v(_vm._s(nav.label))
                                ])
                              ]
                            )
                          ]
                        : [
                            _c(
                              "router-link",
                              _vm._g(
                                {
                                  staticClass: "btn--domain-action",
                                  class: _vm.isNavActiveClass(nav),
                                  attrs: { to: nav.href }
                                },
                                {
                                  click: function() {
                                    if (nav.click) {
                                      nav.click()
                                    }
                                  }
                                }
                              ),
                              [
                                _c("span", {
                                  staticClass: "icon-ccs",
                                  class: nav.icon
                                }),
                                _c("br"),
                                _c("span", { staticClass: "label-ccs" }, [
                                  _vm._v(_vm._s(nav.label))
                                ])
                              ]
                            )
                          ]
                    ]
                  : [
                      _c(
                        "span",
                        {
                          staticClass:
                            "btn--domain-action btn--domain-action--disabled",
                          attrs: {
                            title: _vm.isMainDomain
                              ? "No permissions"
                              : "Not supported for Dev Env"
                          }
                        },
                        [
                          _c("span", {
                            staticClass: "icon-ccs",
                            class: nav.icon
                          }),
                          _c("br"),
                          _c("span", { staticClass: "label-ccs" }, [
                            _vm._v(_vm._s(nav.label))
                          ])
                        ]
                      )
                    ]
              ],
              2
            )
          }),
          _vm._v(" "),
          _c("span", {
            staticClass:
              "ccs-action ccs-action--force-visible ccs-action--next icon-next-ccs icon-ccs",
            attrs: { slot: "button-prev" },
            slot: "button-prev"
          }),
          _vm._v(" "),
          _c("span", {
            staticClass:
              "ccs-action ccs-action--force-visible ccs-action--prev icon-prev-ccs icon-ccs",
            attrs: { slot: "button-next" },
            slot: "button-next"
          })
        ],
        2
      ),
      _vm._v(" "),
      _c("navigation-ccs-modal")
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }